var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(typeof _vm.series === 'object')?_c('apexchart',{attrs:{"height":"300","type":"donut","options":_vm.options,"series":_vm.series}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }